export default __webpack_public_path__ + "static/media/escritorio-vexado.10f85577.webp";